/**
 * @generated SignedSource<<83cfab43118e2c5ec4dcf0a823ef46f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeTrackTimeChooserPopover_timeTrack$data = {
  readonly id: string;
  readonly recordedEnd: string | null | undefined;
  readonly recordedStart: string | null | undefined;
  readonly " $fragmentType": "TimeTrackTimeChooserPopover_timeTrack";
};
export type TimeTrackTimeChooserPopover_timeTrack$key = {
  readonly " $data"?: TimeTrackTimeChooserPopover_timeTrack$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeTrackTimeChooserPopover_timeTrack">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeTrackTimeChooserPopover_timeTrack",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordedStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordedEnd",
      "storageKey": null
    }
  ],
  "type": "TimeTrack",
  "abstractKey": null
};

(node as any).hash = "f832e51609706d171576d4725e99e01f";

export default node;
